import React from 'react';
import PropTypes from 'prop-types';
import './FreeJ2ME.css';

const FreeJ2ME = ({ game }) => {
  const appId = game.id.toString();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const params = new URLSearchParams({
    app: appId,
    fractionScale: '1',
    ...(isMobile && { mobile: '1' })
  });

  const iframeSrc = `/freej2me/web/run.html?${params.toString()}`;

  return (
    <iframe
      src={iframeSrc}
      className="freej2me-iframe"
      title="FreeJ2ME Emulator"
      allow="fullscreen; autoplay; clipboard-read; clipboard-write; cross-origin-isolated"
      frameBorder="0"
    />
  );
};

FreeJ2ME.propTypes = {
  game: PropTypes.object.isRequired
};

export default FreeJ2ME;
